export default __webpack_public_path__ + "static/prioritize-inclusive-bb142d870670ccbe301010f132b2b61d.webm";